/* Adonio – dárek zdarma: když má košík >=2 Essentials produkty a ještě nemá dárek,
   automaticky přidá Supreme trenky se značkou _gift (slevová funkce je pak dá 100% zdarma).
   Zákazník je může z košíku odebrat – pak se pro tuto session znovu nepřidají. */
(function () {
  // barva dárku = ta s víc dostupnými velikostmi (při shodě bílá), viz snippets/ado-pref-barva.liquid
  var BOXER_HANDLES = ['supreme-hanes-boxer-briefs-white', 'supreme-hanes-boxer-briefs-black'];
  var boxerVariant = null;
  var busy = false;

  function ss(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v);
    } catch (e) {}
  }
  function isEss(h) { return h && h.toLowerCase().indexOf('essentials') > -1; }
  function isGiftItem(i) { return i && i.properties && (i.properties._gift === '1' || i.properties._gift === 1 || i.properties._gift === true); }

  async function getBoxer() {
    if (boxerVariant) return boxerVariant;
    try {
      var js = await Promise.all(BOXER_HANDLES.map(function (h) { return fetch('/products/' + h + '.js', { cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }));
      var nA = function (p) { return p ? p.variants.filter(function (x) { return x.available; }).length : -1; };
      var j = nA(js[1]) > nA(js[0]) ? js[1] : (js[0] || js[1]);
      var avail = j.variants.filter(function (x) { return x.available; });
      var m = avail.filter(function (x) { return x.option1 === 'M' || x.public_title === 'M' || x.title === 'M'; })[0] || avail[0] || j.variants[0];
      boxerVariant = m && m.id;
    } catch (e) {}
    return boxerVariant;
  }
  async function getCart() { try { return await (await fetch('/cart.js', { cache: 'no-store' })).json(); } catch (e) { return null; } }

  async function refreshDrawer() {
    try {
      var el = document.querySelector('cart-items-component[data-section-id]');
      var sid = el && el.dataset && el.dataset.sectionId;
      if (sid) {
        var u = new URL('/cart', location.origin); u.searchParams.set('section_id', sid);
        var html = await (await fetch(u.toString(), { cache: 'no-store' })).text();
        var frag = new DOMParser().parseFromString(html, 'text/html');
        var cur = document.getElementById('shopify-section-' + sid), neu = frag.getElementById('shopify-section-' + sid);
        if (cur && neu) cur.innerHTML = neu.innerHTML;
      }
    } catch (e) {}
    try { document.dispatchEvent(Object.assign(new Event('cart:update', { bubbles: true }), { detail: { source: 'agb-gift' } })); } catch (e) {}
  }
  async function addGift() {
    var id = await getBoxer(); if (!id) return false;
    try {
      var r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { '_gift': '1', '_auto': '1' } }] }) });
      return r.ok;
    } catch (e) { return false; }
  }
  async function removeLine(key) {
    try { var r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) }); return r.ok; } catch (e) { return false; }
  }
  async function setLineQty(key, q) {
    try { var r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) }); return r.ok; } catch (e) { return false; }
  }

  async function check() {
    if (busy) return; busy = true;
    try {
      var cart = await getCart(); if (!cart) { busy = false; return; }
      var ess = 0, gift = null;
      cart.items.forEach(function (i) {
        if (isGiftItem(i)) gift = i;
        else if (isEss(i.handle)) ess += i.quantity;
      });
      // Pojistka: dárek zdarma je max 1 na každé 2 Essentials kusy (floor(ess/2)).
      // Kdyby dárková řádka měla víc kusů než nárok, sniž ji na povolený počet.
      var maxGifts = Math.floor(ess / 2);
      if (gift && maxGifts >= 1 && gift.quantity > maxGifts) { await setLineQty(gift.key, maxGifts); await refreshDrawer(); busy = false; return; }
      if (ess < 2) {
        ss('agb_declined', null);
        if (gift && gift.properties && gift.properties._auto) { await removeLine(gift.key); await refreshDrawer(); }
        ss('agb_present', gift ? '1' : '0');
        busy = false; return;
      }
      // ess >= 2
      if (gift) { ss('agb_present', '1'); busy = false; return; }
      if (ss('agb_present') === '1') { ss('agb_declined', '1'); ss('agb_present', '0'); busy = false; return; } // zákazník dárek odebral
      if (ss('agb_declined') === '1') { busy = false; return; }
      var ok = await addGift(); ss('agb_present', '1'); if (ok) await refreshDrawer();
    } catch (e) {}
    busy = false;
  }

  document.addEventListener('cart:update', function (e) { if (e && e.detail && e.detail.source === 'agb-gift') return; setTimeout(check, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(check, 500); });
  else setTimeout(check, 500);
})();
